/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';

import BurgerMenu from './components/BurgerMenu';
import DeleteButton from './components/DeleteButton';
import TextSearch from './components/TextSearch';

const Components = {
    BurgerMenu,
    DeleteButton,
    TextSearch,
};

if (window._bolReactRenderQueue) {
    window._bolReactRenderQueue.forEach(fn => fn(React, ReactDOM, Components));
}



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/register-components.js